import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2bf6bd38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Mis amigos", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = {
  class: "friend blue",
  style: {"float":"right"}
}
const _hoisted_7 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_8 = {
  key: 0,
  class: "notification"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Añadir amigos", -1))
const _hoisted_10 = { class: "search-form" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"70vw","height":"2px"} }, null, -1))
const _hoisted_12 = { class: "image" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  style: {"float":"right"},
  class: "glass red"
}
const _hoisted_16 = {
  style: {"float":"right"},
  class: "glass"
}
const _hoisted_17 = {
  style: {"float":"right"},
  class: "glass"
}

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { ref, onMounted,Ref } from 'vue'
import { useAuth } from '@/store/useAuth'
import AddFriend from '@/components/widgets/AddFriend.vue'
import FriendshipService from '@/services/FriendshipService'
import DeleteFriend from '@/components/widgets/DeleteFriend.vue'
import RequestI from '@/interfaces/RequestInterface'


export default /*#__PURE__*/_defineComponent({
  __name: 'FriendsView',
  setup(__props) {

const loading = ref(true)
const store = useAuth()
const showAddFriend = ref(false)
const showDeleteFriend = ref(false)
const friends:Ref<RequestI[]> = ref([])
const filteredFriends:Ref<RequestI[]>  = ref([])
const service = new FriendshipService()
const search = ref('')
const friendshipRequests = ref([])
const friendToDelete = ref(0)

onMounted(async () => {
    if (!store.token) {
        loading.value = false
        return
    }
    loading.value = true
    friends.value = await service.listUserFriends(store.token)
    filteredFriends.value = friends.value
    friendshipRequests.value = await service.listPendingRequests(store.token)
    loading.value = false
})

const handleSearch = () => {
    loading.value = true
    filteredFriends.value = friends.value.filter(item => item.name?.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}

const handleShowDeleteFriend = (id:number) => {
    friendToDelete.value = id
    showDeleteFriend.value = true
}

const handleFriendDeleted = async () => {
    if (!store.token) {
        loading.value = false
        return
    }
    loading.value = true
    showDeleteFriend.value = false
    friends.value = await service.listUserFriends(store.token)
    filteredFriends.value = friends.value
    search.value = ""
    loading.value = false
   
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (showAddFriend.value)
              ? (_openBlock(), _createBlock(AddFriend, {
                  key: 0,
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (showAddFriend.value = false))
                }))
              : _createCommentVNode("", true),
            (showDeleteFriend.value)
              ? (_openBlock(), _createBlock(DeleteFriend, {
                  key: 1,
                  onClose: handleFriendDeleted,
                  id: friendToDelete.value
                }, null, 8, ["id"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _createVNode(_component_RouterLink, { to: { name: 'friend-request' } }, {
                default: _withCtx(() => [
                  _createElementVNode("button", _hoisted_6, [
                    _createVNode(_component_v_icon, {
                      name: "io-person-add-sharp",
                      class: "icon",
                      hover: "true",
                      animation: "wrench",
                      fill: "white"
                    }),
                    _createElementVNode("p", _hoisted_7, [
                      _createTextVNode(" Ver peticiones de amistad pendientes "),
                      (friendshipRequests.value.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(friendshipRequests.value.length), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                class: "friend",
                style: {"float":"right"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showAddFriend.value = true))
              }, [
                _createVNode(_component_v_icon, {
                  name: "io-person-add-sharp",
                  class: "icon",
                  hover: "true",
                  animation: "wrench",
                  fill: "white"
                }),
                _hoisted_9
              ])
            ]),
            _createElementVNode("form", _hoisted_10, [
              _createVNode(_component_v_icon, { name: "fa-filter" }),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search).value = $event)),
                placeholder: "Filtrar búsqueda",
                onKeyup: handleSearch
              }, null, 544), [
                [_vModelText, search.value]
              ])
            ]),
            _hoisted_11,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFriends.value, (friend) => {
                return (_openBlock(), _createElementBlock("li", {
                  style: {"margin":"2px"},
                  class: "liMessages",
                  key: friend.id
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    (friend.profile_picture_uri)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: friend.profile_picture_uri,
                          width: "128"
                        }, null, 8, _hoisted_13))
                      : (_openBlock(), _createElementBlock("h3", _hoisted_14, _toDisplayString(friend.name?.substring(0, 2)), 1))
                  ]),
                  _createElementVNode("p", null, _toDisplayString(friend.name), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", _hoisted_15, [
                      ((friend.id !== undefined))
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            name: "si-adblock",
                            class: "icon",
                            hover: "true",
                            animation: "wrench",
                            fill: "white",
                            onClick: ($event: any) => (handleShowDeleteFriend(parseInt(friend.id)))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("button", _hoisted_16, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'messages', params: { id: friend.id } }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "ri-message-2-fill",
                            class: "icon",
                            hover: "true",
                            animation: "wrench",
                            fill: "white"
                          })
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("button", _hoisted_17, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'social-profile', params: { id: friend.id } }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "bi-eye-fill",
                            class: "icon",
                            hover: "true",
                            animation: "wrench",
                            fill: "white"
                          })
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})